// used on small screens, when navigation is placed horizontally at the bottom
const bottomTabs = {
  HOME: 'Home',
  TASKS: 'Tasks',
  TRANSACTIONS: 'Transactions',
  MORE: 'More',
};

// used on big screens, when navigation is placed vertiacally on the left side of the screen
const sideBarTabs = {
  HOME: 'Home',
  TASKS: 'Tasks',
  LOG_OUT: 'Log Out',
  LOG_IN: 'Log In',
  HELP_CENTER: 'Help Center',

  // client tabs
  MY_DOCUMENTS: 'My Documents',
  AGENT_PROFILE: 'Agent Profile',

  // realtor tabs
  TRANSACTIONS: 'Transactions',
  CLIENTS: 'Clients',
  MY_LISTEDKITS: 'Transaction Kits',
  EMAIL_TEMPLATES: 'Email Templates',
  SERVICE_PROVIDERS_LIST: 'Service Providers List',
  INTEGRATIONS: 'Integrations',
  SETTINGS: 'Settings',
  ADVANCED_FIELDS: 'Advanced Fields',

  // coordinator tabs
  E_SIGN_TEMPLATES: 'eSignature Templates',
  TEAMS: 'Teams & Agents',
  USERS: 'Users',
};

const settingsTab = {
  DETAILS: 'Details',
  BILLING: 'Billing',
  NOTIFICATIONS: 'Notifications',
  CUSTOMIZATION: 'Customization',
};

const transactionTabs = {
  TASKS: 'Tasks',
  DOCS: 'Docs',
  DETAILS: 'Details',
  HISTORY: 'History',
  NOTES: 'Notes',
};

const auditTabs = {
  TASKS: 'Tasks',
  DOCS: 'Documents',
};

const pipelineTabs = {
  TRANSACTIONS: 'Transactions',
  CLIENTS: 'Clients',
};

const teamMemberTabs = {
  PIPELINE: 'Transactions & Clients',
  DETAILS: 'Details',
  NOTES: 'Notes',
};

const clientProfileTabs = {
  TRANSACTIONS: 'Transactions',
  NOTES: 'Notes',
};

const uploadDocumentsModalTabs = {
  UPLOAD_FROM_COMPUTER: 'Upload from Computer or Device',
  ATTACH_FROM_LISTED_KIT: 'Attach from ListedKit',
};

export {
  bottomTabs,
  sideBarTabs,
  settingsTab,
  transactionTabs,
  auditTabs,
  pipelineTabs,
  teamMemberTabs,
  clientProfileTabs,
  uploadDocumentsModalTabs,
};
